/**
 * Helpers de validación reutilizables para el formulario CreaSolicitudYupana.
 * Cada función retorna el mensaje de error (string) si falla, o null si es válido.
 */

// Acepta letras (a-z, A-Z), tildes, ü/Ü, ñ/Ñ y espacios internos entre palabras.
// Requiere al menos un carácter que no sea espacio.
const SOLO_LETRAS = /^[A-Za-zÁÉÍÓÚáéíóúÜüÑñ][A-Za-zÁÉÍÓÚáéíóúÜüÑñ\s]*$/;

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const TELEFONO_REGEX = /^\d{10}$/;

/** Texto obligatorio — falla si está vacío o es solo espacios */
export const validarTexto = (valor) => {
    if (!valor || valor.trim().length === 0)
        return 'El campo no puede estar vacío ni contener solo espacios.';
    return null;
};

/**
 * Solo letras (campo obligatorio).
 * @param {string} valor
 * @param {string} msgError - Mensaje a mostrar cuando falla
 */
export const validarSoloLetras = (valor, msgError) => {
    if (!valor || valor.trim().length === 0) return msgError;
    if (!SOLO_LETRAS.test(valor.trim())) return msgError;
    return null;
};

/**
 * Solo letras (campo opcional).
 * Pasa vacío; si tiene valor, debe cumplir el regex de solo letras.
 */
export const validarSoloLetrasOpcional = (valor, msgError) => {
    if (!valor || valor.trim().length === 0) return null;
    if (!SOLO_LETRAS.test(valor.trim())) return msgError;
    return null;
};

/**
 * Nombre completo — letras + mínimo 2 palabras (nombre y apellido).
 */
export const validarNombreCompleto = (valor) => {
    const errLetras = validarSoloLetras(valor, 'Ingrese un nombre válido, solo letras.');
    if (errLetras) return errLetras;
    return null;
};

/** Teléfono — exactamente 10 dígitos numéricos */
export const validarTelefono = (valor) => {
    if (!valor || String(valor).trim().length === 0)
        return 'El teléfono debe tener exactamente 10 dígitos.';
    if (!TELEFONO_REGEX.test(String(valor).trim()))
        return 'El teléfono debe tener exactamente 10 dígitos.';
    return null;
};

/** Celular — exactamente 10 dígitos numéricos */
export const validarCelular = (valor) => {
    if (!valor || String(valor).trim().length === 0)
        return 'El celular debe tener exactamente 10 dígitos.';
    if (!TELEFONO_REGEX.test(String(valor).trim()))
        return 'El celular debe tener exactamente 10 dígitos.';
    return null;
};

/** Email obligatorio con formato válido */
export const validarEmail = (valor) => {
    if (!valor || valor.trim().length === 0)
        return 'Ingrese un correo electrónico válido.';
    if (!EMAIL_REGEX.test(valor.trim()))
        return 'Ingrese un correo electrónico válido.';
    return null;
};

/** Número entero ≥ 0 (para cargas familiares) */
export const validarEnteroPositivo = (valor) => {
    if (valor === '' || valor === null || valor === undefined)
        return 'Las cargas familiares deben ser un número entero igual o mayor a 0.';
    const num = Number(valor);
    if (isNaN(num) || !Number.isInteger(num) || num < 0)
        return 'Las cargas familiares deben ser un número entero igual o mayor a 0.';
    return null;
};

/** Select obligatorio — falla si está vacío */
export const validarSelect = (valor, msg) => {
    if (!valor || valor === '') return msg;
    return null;
};
